import localization from "../../statics/localization";

// MW currently exposes a menu name, but no visual theme discriminator.
// Match root menu names only; a child's title must not theme its parent menu.
export function isKidsMenu(name) {
  const normalized = String(name || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/ı/g, "i")
    .replace(/\s+/g, " ");
  return [
    "kids",
    "children",
    "cocuk",
    "cocuk ve egitim",
    "cocuk & egitim"
  ].includes(normalized);
}

const copy = {
  tr: {
    eyebrow: "HAYAL GÜCÜNE YER AÇ!",
    title: "Kocaman hayaller,",
    highlight: "rengârenk maceralar!",
    description: "Sevdiğin kahramanlarla gül, öğren, hayal et.",
    sticker: "Merhaba, arkadaşım!",
    previewEyebrow: "BİRLİKTE KEŞFEDELİM",
    footer: "Her renk, yepyeni bir hikâye.",
    explore: "Hadi keşfet",
    selection: "BİRLİKTE KEŞFETMEK DAHA GÜZEL",
    discover: "Bugün ne izleyelim?",
    cinema: "HAYAL ET. KEŞFET. EĞLEN."
  },
  eng: {
    eyebrow: "MAKE ROOM FOR IMAGINATION!",
    title: "Big dreams,",
    highlight: "colourful adventures!",
    description: "Laugh, learn and imagine with your favourite characters.",
    sticker: "Hello, my friend!",
    previewEyebrow: "LET’S EXPLORE TOGETHER",
    footer: "Every colour tells a new story.",
    explore: "Let's explore",
    selection: "EXPLORING IS BETTER TOGETHER",
    discover: "What shall we watch today?",
    cinema: "IMAGINE. EXPLORE. PLAY."
  },
  arb: {
    eyebrow: "أفسح المجال لخيالك!",
    title: "أحلام كبيرة،",
    highlight: "ومغامرات ملوّنة!",
    description: "اضحك وتعلّم وتخيّل مع شخصياتك المفضّلة.",
    sticker: "مرحبًا يا صديقي!",
    previewEyebrow: "لنستكشف معًا",
    footer: "مع كل لون، قصة جديدة.",
    explore: "هيا نستكشف",
    selection: "الاستكشاف معًا أجمل",
    discover: "ماذا نشاهد اليوم؟",
    cinema: "تخيّل. استكشف. استمتع."
  }
};
export const getKidsCopy = () => copy[localization.getLanguage()] || copy.eng;
